var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flash-holder"},_vm._l((_vm.flashInfo),function(msg,i){return _c('div',{key:i,class:['alert', 'alert-' + msg.state]},[_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(msg.message))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }